import { Form, FormInstance, Tabs } from 'antd';
import { useIntl } from 'react-intl';
import { InvoiceDocReferencedTable } from '../InvoiceDocReferenced';
import {
  InvoiceCreateDTO,
  InvoiceGeneralFormValues,
} from '@/core/domain/invoice/invoice/Invoice.types';
import InvoiceAllForm from '../../InvoiceCreateModal/InvoiceAllForm';
import { InvoiceType } from '@/core/domain/invoice/invoices/invoices.enums';
import { useInvoiceFormContext } from '../../InvoiceFormProvider';

type Props = {
  tabTitle: string;
  form: FormInstance<InvoiceGeneralFormValues>;
  invoiceData?: InvoiceCreateDTO;
};

const InvoiceFormTabs: React.FC<Props> = ({ form, tabTitle, invoiceData }) => {
  const intl = useIntl().formatMessage;

  const {
    invoice: { data: invoice },
  } = useInvoiceFormContext();

  return (
    <>
      <Tabs defaultActiveKey="1">
        <Tabs.TabPane tab={tabTitle} key="1">
          <Form form={form} name="invoiceGeneral">
            <InvoiceAllForm
              form={form}
              isEdit
              selecteInvoiceType={
                tabTitle === 'NFE'
                  ? InvoiceType.NFE
                  : tabTitle === 'NFS'
                  ? InvoiceType.NFS
                  : InvoiceType.NFC
              }
              invoiceData={invoiceData}
            />
          </Form>
        </Tabs.TabPane>

        {invoice?.invoiceType && invoice.invoiceType === InvoiceType.NFE && (
          <Tabs.TabPane
            tab={intl({
              id: 'layout.menu.fiscal.invoice.referenced',
            })}
            key="referenced"
          >
            <InvoiceDocReferencedTable form={form} />
          </Tabs.TabPane>
        )}
      </Tabs>
    </>
  );
};

export default InvoiceFormTabs;
